export default __webpack_public_path__ + "static/media/About.2c30cacd.png";